export default __webpack_public_path__ + "static/media/Theresa Rich.4f63712f.jpg";